import { render } from "./LanguageGroup.vue?vue&type=template&id=58990d3f"
import script from "./LanguageGroup.vue?vue&type=script&lang=js"
export * from "./LanguageGroup.vue?vue&type=script&lang=js"

import "./LanguageGroup.vue?vue&type=style&index=0&id=58990d3f&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__